module.exports = __webpack_public_path__ + "img/Group 618.c0f17620.png";